import { render, staticRenderFns } from "./AdminBrandEdit.vue?vue&type=template&id=2fc46250"
import script from "./AdminBrandEdit.vue?vue&type=script&lang=js"
export * from "./AdminBrandEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports